import { dom } from './dom.js';
import { state } from './state.js';
import { Utils } from './utils.js';
import { Search } from './search.js';

export const TreeRenderer = {
  render(data) {
    state.nodeId = 0;
    dom.outputArea.replaceChildren(TreeRenderer.buildNode(data, { key: null, index: null }));
    Search.apply();
  },

  buildNode(value, meta) {
    const type = Utils.getType(value);
    return Utils.isContainer(value)
      ? TreeRenderer.buildContainerNode(value, meta, type)
      : TreeRenderer.buildLeafNode(value, meta, type);
  },

  buildContainerNode(value, meta, type) {
    const container = document.createElement('div');
    container.className = 'node-container';
    container.dataset.nodeId = `n${++state.nodeId}`;

    const row = document.createElement('div');
    row.className = 'node-row';

    const toggle = Utils.createSpan('toggle', '▾');
    toggle.dataset.action = 'toggle-node';
    row.appendChild(toggle);

    TreeRenderer.appendMeta(row, meta);

    const openBracket = type === 'object' ? '{' : '[';
    const closeBracket = type === 'object' ? '}' : ']';
    const entries = type === 'object'
      ? Object.entries(value)
      : value.map((item, index) => [index, item]);

    row.appendChild(Utils.createSpan('bracket', openBracket));

    const preview = Utils.createSpan(
      'inline-preview',
      ` … ${entries.length} ${type === 'array' ? 'items' : 'keys'} ${closeBracket}`
    );
    row.appendChild(preview);

    row.appendChild(
      Utils.createSpan('count node-count', ` ${entries.length} ${type === 'array' ? 'items' : 'keys'}`)
    );

    if (state.showTypes) {
      row.appendChild(Utils.createSpan('type-badge', type));
    }

    container.appendChild(row);

    const children = document.createElement('div');
    children.className = 'tree-children';

    entries.forEach(([entryKey, entryValue]) => {
      const childMeta = type === 'object'
        ? { key: entryKey, index: null }
        : { key: null, index: entryKey };
      children.appendChild(TreeRenderer.buildNode(entryValue, childMeta));
    });

    container.appendChild(children);

    const closeRow = document.createElement('div');
    closeRow.className = 'node-row tree-close';
    closeRow.appendChild(Utils.createSpan('spacer', ''));
    closeRow.appendChild(Utils.createSpan('bracket', closeBracket));
    container.appendChild(closeRow);

    return container;
  },

  buildLeafNode(value, meta, type) {
    const row = document.createElement('div');
    row.className = 'node-row';
    row.appendChild(Utils.createSpan('spacer', ''));
    TreeRenderer.appendMeta(row, meta);

    let displayText = 'null';
    let className = 'null';

    if (type === 'string') {
      displayText = `"${value}"`;
      className = 'str';
    } else if (type === 'number') {
      displayText = String(value);
      className = 'num';
    } else if (type === 'boolean') {
      displayText = String(value);
      className = 'bool';
    }

    const valueSpan = Utils.createSpan(className, displayText);
    valueSpan.dataset.value = String(value);
    row.appendChild(valueSpan);

    if (state.showTypes) {
      row.appendChild(Utils.createSpan('type-badge', type));
    }

    return row;
  },

  appendMeta(row, meta) {
    if (meta.key !== null) {
      row.appendChild(Utils.createSpan('key', `"${meta.key}"`));
      row.appendChild(Utils.createSpan('colon', ': '));
    }

    if (meta.index !== null && state.showIdx) {
      row.appendChild(Utils.createSpan('idx-badge', String(meta.index)));
      row.appendChild(Utils.createSpan('colon', ' '));
    }
  },
};
